var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdviserSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90906 7.09091C5.90906 3.65442 8.68469 1.5 12.1212 1.5C15.5577 1.5 18.3333 4.27563 18.3333 7.71212",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59844 5.84848H4.97723C4.80569 5.84848 4.66663 6.07099 4.66663 6.34545V10.3212C4.66663 10.5957 4.80569 10.8182 4.97723 10.8182H5.59844C5.76999 10.8182 5.90905 10.5957 5.90905 10.3212V6.34545C5.90905 6.07099 5.76999 5.84848 5.59844 5.84848Z",
    fill: "#F4F4F9",
    stroke: "#F4F4F9",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2652 5.84848H18.644C18.4724 5.84848 18.3334 6.07099 18.3334 6.34545V10.3212C18.3334 10.5957 18.4724 10.8182 18.644 10.8182H19.2652C19.4367 10.8182 19.5758 10.5957 19.5758 10.3212V6.34545C19.5758 6.07099 19.4367 5.84848 19.2652 5.84848Z",
    fill: "#F4F4F9",
    stroke: "#F4F4F9",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9545 11.4394C18.9545 14.2428 16.3025 17.2788 13.6742 17.2788H12.1212",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0087 16.0364H11.2338C11.0377 16.0364 10.8788 16.1754 10.8788 16.347V16.9682C10.8788 17.1397 11.0377 17.2788 11.2338 17.2788H13.0087C13.2047 17.2788 13.3636 17.1397 13.3636 16.9682V16.347C13.3636 16.1754 13.2047 16.0364 13.0087 16.0364Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.1275C17.5264 14.1275 19.0821 18.0901 19.4837 20.1359C19.6122 20.7904 18.9622 21.3275 18.1465 21.3275H4.85352C4.03779 21.3275 3.38779 20.7904 3.51626 20.1359C3.91783 18.0901 5.4735 14.1275 11.5 14.1275Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdviserSupport);
export default __webpack_public_path__ + "static/media/AdviserSupport.3c39cde3f36e16561c8b35a772ddc5fa.svg";
export { ForwardRef as ReactComponent };